"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateInternalSettings = exports.fetchInternalSettings = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
/**
 * Load internal settings.
 *
 * @param url Url of service
 */
function fetchInternalSettings(url) {
    return abortable_fetch_1.abortableFetch(url, {
        method: 'GET',
    });
}
exports.fetchInternalSettings = fetchInternalSettings;
/**
 * Saves internal settings.
 *
 * @param url Url of service
 */
function updateInternalSettings(url, settings) {
    return abortable_fetch_1.abortableFetch(url, {
        method: 'PUT',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(settings),
    });
}
exports.updateInternalSettings = updateInternalSettings;
//# sourceMappingURL=internal-settings-api.js.map